module.exports = __webpack_public_path__ + "static/img/7-4.6f89c2d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/7-4.png
// module id = yXq3
// module chunks = 0